import { BehaviorSubject, Observable } from 'rxjs'

import { Injectable } from '@angular/core'

@Injectable({
    providedIn: 'root'
})
export class SidebarService {
    private readonly STORAGE_KEY = 'kartorium_sidebar_collapsed'
    private _collapsed$ = new BehaviorSubject<boolean>(this.getInitialState())

    public collapsed$: Observable<boolean> = this._collapsed$.asObservable()

    get isCollapsed(): boolean {
        return this._collapsed$.value
    }

    constructor() { }

    private getInitialState(): boolean {
        try {
            const stored = localStorage.getItem(this.STORAGE_KEY)
            // Default to collapsed (true) for cleaner initial view
            return stored ? stored === 'true' : true
        } catch (error) {
            // localStorage may be disabled or throw security exceptions
            return true
        }
    }

    toggle(): void {
        const newState = !this._collapsed$.value
        this._collapsed$.next(newState)
        try {
            localStorage.setItem(this.STORAGE_KEY, String(newState))
        } catch (error) {
            // localStorage may be disabled or throw security exceptions
        }
    }

    collapse(): void {
        this._collapsed$.next(true)
        try {
            localStorage.setItem(this.STORAGE_KEY, 'true')
        } catch (error) {
            // localStorage may be disabled or throw security exceptions
        }
    }

    expand(): void {
        this._collapsed$.next(false)
        try {
            localStorage.setItem(this.STORAGE_KEY, 'false')
        } catch (error) {
            // localStorage may be disabled or throw security exceptions
        }
    }


}
